import { DEFAULT_STUDIO_THEME_COLOR } from '../../Tools/hotTopicStudio/constants';

export interface CustomHotTopicPack {
  themeColor?: string;
  pages: any[];
}

export interface NewsStudioItem {
  id: string | number;
  title: { en: string; zh: string; 'zh-Hant-HK': string };
  studioPackPages: any[];
  studioPackThemeColor: string;
}

const isPackWithPages = (value: unknown): value is CustomHotTopicPack =>
  !!value && typeof value === 'object' && Array.isArray((value as CustomHotTopicPack).pages) && (value as CustomHotTopicPack).pages.length > 0;

const parseCustomHotTopic = (raw: unknown): unknown => {
  if (raw == null) {
    return null;
  }
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
};

export const getCustomHotTopicPack = (news: any): CustomHotTopicPack | null => {
  if (!news) {
    return null;
  }

  const parsed = parseCustomHotTopic(news.custom_hottopic);
  if (isPackWithPages(parsed)) {
    return parsed;
  }

  if (parsed && typeof parsed === 'object' && isPackWithPages((parsed as { text?: unknown }).text)) {
    return (parsed as { text: CustomHotTopicPack }).text;
  }

  return null;
};

const toLocalizedTitle = (title: any): NewsStudioItem['title'] => {
  if (title && typeof title === 'object') {
    const en = title.en || title['zh-Hant-HK'] || title.zh || '';
    const zh = title.zh || title['zh-Hant-HK'] || title.en || '';
    const zhHant = title['zh-Hant-HK'] || title.zh || title.en || '';
    return { en, zh, 'zh-Hant-HK': zhHant };
  }

  const text = title || '';
  return { en: text, zh: text, 'zh-Hant-HK': text };
};

export const newsToStudioPack = (news: any): NewsStudioItem | null => {
  const pack = getCustomHotTopicPack(news);
  if (!pack || !news) {
    return null;
  }

  return {
    id: news.news_id || news.id,
    title: toLocalizedTitle(news.title),
    studioPackPages: pack.pages,
    studioPackThemeColor: pack.themeColor || DEFAULT_STUDIO_THEME_COLOR
  };
};
